'use client'

import React, { ReactNode } from 'react'

import { usePathname } from 'next/navigation'

import {
  PublicInviteLayout,
  PublicLayout,
  RSVPLayout,
  RSVPPublicLayout,
} from 'Components/Layouts'

import {
  EVENTS,
  EXECUTIVE_INVITE,
  MAGIC_LINK_AUTH,
  PRIVACY_POLICY,
  RSVP_ROUTE,
  TERMS_CONDITIONS,
  TEST,
} from 'Constants/Paths'

import 'react-toastify/dist/ReactToastify.min.css'

type Props = Readonly<{
  children: ReactNode
}>

export default function LayoutGate({ children }: Props) {
  const pathname = usePathname()

  if (pathname?.startsWith(MAGIC_LINK_AUTH)) {
    return <RSVPPublicLayout>{children}</RSVPPublicLayout>
  }

  if (pathname?.endsWith(RSVP_ROUTE)) {
    return <RSVPLayout>{children}</RSVPLayout>
  }

  if (pathname?.startsWith(EVENTS)) {
    return <PublicLayout secondary>{children}</PublicLayout>
  }

  if (
    pathname?.startsWith(TERMS_CONDITIONS) ||
    pathname?.startsWith(PRIVACY_POLICY)
  ) {
    return <PublicLayout hideMobileHeader>{children}</PublicLayout>
  }

  if (pathname?.startsWith(TEST)) {
    return <>{children}</>
  }

  if (pathname?.startsWith(EXECUTIVE_INVITE)) {
    return <PublicInviteLayout>{children}</PublicInviteLayout>
  }

  return <PublicLayout>{children}</PublicLayout>
}
